import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "../styles/_app.css";
import { ROUTES } from "./AppRouterConfig";

// Лейауты
import PageLayout from "../components/common/layouts/PageLayout";
import SelectionLayout from "../components/common/layouts/SelectionLayout";

// Страницы
import Home from "../components/Pages/Home";
import About from "../components/Pages/About";
import ProductsRange from "../components/Pages/Products/ProductsRange";
import ProductsSeries from "../components/Pages/Products/ProductsSeries";
import ProductsDetails from "../components/Pages/Products/ProductsDetails";
import SelectionType from "../components/Pages/SelectionType";
import Documentation from "../components/Pages/Documentation/Documentation";
import PriceList from "../components/Pages/PriceList";
import Balances from "../components/Pages/Balances";
import Contacts from "../components/Pages/Contacts/Contacts";
import News from "../components/Pages/News";
import References from "../components/Pages/References";
import RateHistory from "../components/Pages/RateHistory";
import PrivacyPolicy from "../components/Pages/PrivacyPolicy";
import NotFound from "../components/Pages/NotFound";
// import Admin from "../components/Pages/Admin";

// Страницы-компоненты
import PumpsRange from "../components/Pages/Pumps/PumpsRange";
import PumpsSelection from "../components/Pages/Pumps/Selection/PumpsSelection";

// import UserPrivateRoute from "../components/common/UserPrivateRoute";
import DevRoute from "../components/common/DevRoute";

const AppRouter = () => {
  return (
    <Router basename="/">
      <Routes>
        {/* Страницы сайта */}
        <Route element={<PageLayout />}>
          {/* Приватные маршруты пользователя */}
          {/* <Route element={<UserPrivateRoute />}>
            <Route path={ROUTES.Admin.path} element={<Admin />} />
          </Route> */}

          {/* Главная */}
          <Route path={ROUTES.Home.path} element={<Home />} />
          {/* О бренде */}
          <Route path={ROUTES.About.path} element={<About />} />
          {/* Продукты */}
          <Route path={ROUTES.ProductsRange.path} element={<ProductsRange />} />
          <Route
            path={ROUTES.ProductsSeries.path}
            element={<ProductsSeries />}
          />
          <Route
            path={ROUTES.ProductsDetails.path}
            element={<ProductsDetails />}
          />
          {/* Программа подбора */}
          <Route path={ROUTES.SelectionType.path} element={<SelectionType />} />

          {/* Подбор по сериям */}
          <Route element={<SelectionLayout />}>
            {/* Выбор серии */}
            <Route path={ROUTES.PumpsRange.path} element={<PumpsRange />} />
            {/* Форма подбора и результаты */}
            <Route
              path={ROUTES.PumpsSelection.path}
              element={<PumpsSelection />}
            />
          </Route>

          {/* Документация */}
          <Route
            path={ROUTES.Documentation.path}
            element={
              <Navigate to={ROUTES.DocumentationCatalogs.path} replace />
            }
          />
          <Route
            path={ROUTES.DocumentationCatalogs.path}
            element={<Documentation />}
          />
          <Route
            path={ROUTES.DocumentationCertificates.path}
            element={<Documentation />}
          />
          <Route
            path={ROUTES.DocumentationInstructions.path}
            element={<Documentation />}
          />
          <Route
            path={ROUTES.DocumentationDrawings.path}
            element={<Documentation />}
          />
          <Route
            path={ROUTES.DocumentationDrawingsSection.path}
            element={<Documentation />}
          />
          {/* Временно скрыты */}
          {/* <Route
            path={ROUTES.DocumentationBimModels.path}
            element={<Documentation />}
          /> */}
          {/* Прайс лист */}
          <Route path={ROUTES.PriceList.path} element={<PriceList />} />
          {/* Складские остатки */}
          <Route path={ROUTES.Balances.path} element={<Balances />} />
          {/* Контакты */}
          <Route path={ROUTES.Contacts.path} element={<Contacts />} />

          {/* Новости */}
          <Route path={ROUTES.News.path} element={<News />} />
          {/* Референции */}
          <Route path={ROUTES.References.path} element={<References />} />
          {/* История курса */}
          <Route path={ROUTES.RateHistory.path} element={<RateHistory />} />
          {/* Политика конфиденциальности */}
          <Route path={ROUTES.PrivacyPolicy.path} element={<PrivacyPolicy />} />

          {/* Страница не найдена */}
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Dev-калькулятор — скрытый маршрут, только для админов */}
        <Route element={<DevRoute />}>
          <Route element={<PageLayout />}>
            <Route element={<SelectionLayout />}>
              <Route
                path={ROUTES.PumpsRangeDev.path}
                element={<PumpsRange />}
              />
              <Route
                path={ROUTES.PumpsSelectionDev.path}
                element={<PumpsSelection />}
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
